import { render, staticRenderFns } from "./globalHeader.vue?vue&type=template&id=2289358e"
import script from "./globalHeader.vue?vue&type=script&lang=ts"
export * from "./globalHeader.vue?vue&type=script&lang=ts"
import style0 from "./globalHeader.vue?vue&type=style&index=0&id=2289358e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports